


export enum ClientEvent {
    TokenExpired = "tokenExpired",
    TokenAboutToExpire = "tokenAboutToExpire",
    TokenUpdated = "tokenUpdated",
    TokenAutoUpdateFailed = "tokenAutoUpdateFailed",
    TokenMaxLifetimeReached = "tokenMaxLifetimeReached",
    ConnectionLost = "connectionLost",
    ConnectionRestored = "connectionRestored",
    Disconnected = "disconnected",
    IncomingCall = "incomingCall",
    ClientDestroyed = "clientDestroyed"
}




export enum ConversationClientEvent {
    ConversationAdded = "conversationAdded",
    ConversationJoined = "conversationJoined",
    ConversationLeft = "conversationLeft",
    ConversationRemoved = "conversationRemoved",
    ConversationUpdated = "conversationUpdated",
    ParticipantJoined = "participantJoined",
    ParticipantLeft = "participantLeft",
    ParticipantUpdated = "participantUpdated",
    MessageAdded = "messageAdded",
    MessageRemoved = "messageRemoved",
    MessageUpdated = "messageUpdated",
    TokenAboutToExpire = "tokenAboutToExpire",
    TokenExpired = "tokenExpired",
    TypingEnded = "typingEnded",
    TypingStarted = "typingStarted",
    PushNotification = "pushNotification",
    UserSubscribed = "userSubscribed",
    UserUnsubscribed = "userUnsubscribed",
    UserUpdated = "userUpdated",
    StateChanged = "stateChanged",
    Initialized = "initialized",
    InitFailed = "initFailed",
    ConnectionStateChanged = "connectionStateChanged",
    ConnectionError = "connectionError"
}
